import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isMetaPage, trackMetaPageView } from '../lib/metaPixel';

export default function MetaPixelTracking() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const previous = useRef(null);
  useEffect(() => {
    if (pathname === '/dashboard/planes') {
      const parameters = new URLSearchParams(search);
      for (const key of [...parameters.keys()]) {
        if (!isMetaPage({ pathname, search: `?${encodeURIComponent(key)}=value` })) parameters.delete(key);
      }
      if (parameters.toString() !== new URLSearchParams(search).toString()) {
        navigate({ pathname, search: parameters.toString() }, { replace: true });
        return;
      }
    }
    // React StrictMode and payment-query changes do not duplicate page views.
    if (previous.current === pathname) return;
    if (trackMetaPageView()) previous.current = pathname;
    else previous.current = null;
  }, [pathname, search, navigate]);
  return null;
}
